export default [
  {
    path: '/event-closed',
    component: () => import('@/views/EventClosed.vue'),
    name: 'event-closed',
    meta: {
      navName: 'event-closed',
      sideNav: true,
      requiresAuth: true
    },
  },

  {
    path: '/event-closed/:id',
    component: () => import('@/views/EventClosed/Edit.vue'),
    name: 'event-closed-edit',
    meta: {
      navName: 'event-closed',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/event-closed/:id/entry',
    component: () => import('@/views/EntryClosed.vue'),
    name: 'event-closed-entry',
    meta: {
      navName: 'event-closed',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/event-closed/:id/export',
    component: () => import('@/views/EventClosed/Export.vue'),
    name: 'event-closed-export',
    meta: {
      navName: 'event-closed',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/event-closed/:id/quizset',
    component: () => import('@/views/EventClosed/Quizset.vue'),
    name: 'event-closed-quizset',
    meta: {
      navName: 'event-closed',
      sideNav: true,
      requiresAuth: true
    }
  }

]

